module.exports = __webpack_public_path__ + "img/vip-banner-bg.a9814391.png";